module.exports = __webpack_public_path__ + "img/logo.03a62e72.svg";